import React, { useState } from "react";
import { Modal, Row, Col, Checkbox, Button } from "react-bootstrap";

import "./index.scss";
import { ls } from "../../../../locale";

export default function SelectFlightWindow({ isShow, passengers, onClose }) {

  const [selected, setSelected] = useState([]);

  const onConfirm = () => {
    if (selected.length > 0) {
      onClose(selected);
    }
  }

  const toggleSelection = passenger => {
    if (!passenger?.id) return;

    if (selected.find(x => x.id === passenger.id)) {
      setSelected(selected.filter(x => x.lapChildId !== passenger.id && x.id !== passenger.id))
    }
    else {
      const infants = passengers.filter(x => x.lapChildId === passenger.id);
      setSelected([...selected, passenger, ...infants])
    }
  }

  const rButton = ls.t('Button');

  return (
    <Modal className={ls.t("rootClass")} show={isShow} onHide={() => onClose()} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Cancel Passenger</Modal.Title>
      </Modal.Header>
      <Modal.Body className="flight-select-body">
        <p>Please select passengers to cancel</p>

        {Array.isArray(passengers) && passengers.map(passenger => {
          const checked = selected.find(x => x.id === passenger.id) || false;
          const disabled = (passenger.lapChildId > 0 && selected.find(x => x.id === passenger.lapChildId)) || false

          return (
            <Row key={passenger.id} className="flight-section">
              <Col md={12}>
                <Checkbox checked={checked} onClick={() => toggleSelection(passenger)} onChange={() => { }} disabled={disabled}>
                  <label></label>
                </Checkbox>
                <div className="flight-details">
                  <span>{passenger.firstName} {passenger.lastName}</span>
                </div>
              </Col>
            </Row>)
        })}
      </Modal.Body>
      <Modal.Footer>
        <div className="flight-select-footer">
          <div> </div>
          <Button onClick={onConfirm}>{rButton.Select}</Button>
        </div>
      </Modal.Footer>
    </Modal>
  )

}
